import styled from 'styled-components'

const ReportSummaryPercentIndicatorInfoLabel = styled.div`
  color: #626262;
  font-size: 14px;
  font-weight: 500;
`

export default ReportSummaryPercentIndicatorInfoLabel